import styled from 'styled-components';
import { Columns } from '@components/Columns';
import { marcomTheme } from '@components/themes';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';

export const TitleTextWrapper = styled(TextPairing)`
  .text-pairing-title {
    max-width: 570px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      margin: 0 auto;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 750px;
    }
  }
`;

export const BottomAlignedColumns = styled(Columns)`
  align-items: flex-end;
  text-align: center;
  ${themeMediaQuery('sm')} {
    text-align: left;
  }
`;

export const RSVPTrackingColumns = styled(Columns)`
  margin-top: ${themeSpace(9)};
  margin-bottom: ${themeSpace(9)};
  ${themeMediaQuery('below_sm')} {
    padding: 0 ${themeSpace(5)};
    margin-top: ${themeSpace(6)};
  }
`;

export const WeddingFirstColumns = styled(Columns)`
  margin-top: ${themeSpace(9)};
  margin-bottom: ${themeSpace(9)};
  ${themeMediaQuery('below_sm')} {
    padding-top: ${themeSpace(0)};
    margin-top: ${themeSpace(0)};
  }
`;

export const StyledText = styled(Text)`
  max-width: 100%;
  ${themeMediaQuery('sm')} {
    max-width: 360px;
  }
  ${themeMediaQuery('below_sm')} {
    max-width: 302px;
    margin: 0 auto;
  }
`;

export const StyledNumber = styled(Text)`
  font-family: AkkuratLLSub-LightSubset;
`;

export const StyledRSVPTrackingCountsWrapper = styled(Box)<{
  lastIndex: boolean;
}>`
  display: ${(props) => (props.lastIndex ? 'none' : 'block')};
  ${marcomTheme.mediaQueries.md} {
    display: block;
  }
  &:not-last-of-type {
    margin-right: 4rem;
  }
`;

export const ButtonWrapper = styled(Box)`
  ${themeMediaQuery('below_sm')} {
    display: flex;
    justify-content: center;
    margin-top: 16px;
    margin-bottom: ${themeSpace(12)};
  }
`;

export const MainLottieWrapper = styled(Box)`
  margin-top: ${themeSpace(10)};
`;

export const DesktopColumns = styled(Columns)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ColumnsContainer = styled(Columns.Column)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  svg {
    min-width: 100%;
    height: auto !important;
  }
`;
